<template>
	<div>
		<header>
			<h1>Invitation</h1>
			<div v-if="activeItem">
				<ul>
					<li v-if="$can('convertToServiceProvider', activeItem)">
						<router-link
							:to="{name: 'serviceProviders.create', query: {invitation: activeItem.id}}"
							class="button button--primary--small">Convert to Service Provider</router-link>
					</li>
				</ul>
			</div>
		</header>
		<div>
			<div v-if="!activeItem" class="section">
				<loader/>
			</div>
			<div v-if="activeItem" class="client">
				<div class="sections">
					<section class="section">
						<header>
							<h1 class="beta">Invitation Details</h1>
						</header>
						<div class="detail-list">
							<dl class="detail-list__item">
								<dt>Type</dt>
								<dd v-html="$enum('InvitationTypesEnum').display(activeItem.invitation_type)"/>
							</dl>
							<template v-if="activeItem.service_provider_type">
								<dl class="detail-list__item">
									<dt>Service Provider Type</dt>
									<dd v-html="$enum('ServiceProviderTypes').display(activeItem.service_provider_type)"/>
								</dl>
								<dl class="detail-list__item">
									<dt>Service Provider Name</dt>
									<dd v-html="activeItem.service_provider_name"/>
								</dl>
							</template>
							<dl class="detail-list__item">
								<dt>Email Sent</dt>
								<dd>
									<bool-icon :value="activeItem.email_sent"/>
								</dd>
							</dl>
							<dl class="detail-list__item">
								<dt>Complete</dt>
								<dd>
									<bool-icon :value="activeItem.complete"/>
								</dd>
							</dl>
						</div>
					</section>
					<section class="section">
						<header>
							<h1 class="beta">Contact</h1>
						</header>
						<div class="detail-list">
							<dl class="detail-list__item">
								<dt>Name</dt>
								<dd v-html="activeItem.contact_name_first + ' ' + activeItem.contact_name_last"></dd>
							</dl>
							<dl class="detail-list__item">
								<dt>Email</dt>
								<dd v-html="activeItem.contact_email.formatted"></dd>
							</dl>
							<dl class="detail-list__item">
								<dt>Phone</dt>
								<dd v-html="activeItem.contact_phone"></dd>
							</dl>
						</div>
					</section>
					<template v-if="activeItem.complete">
						<template v-if="$enum('InvitationTypesEnum').serviceProvider === activeItem.invitation_type">
							<template
								v-if="$enum('ServiceProviderTypes').estateAgent === activeItem.service_provider_type">
								<section class="section">
									<header>
										<h1 class="beta">Agreements</h1>
									</header>
									<div class="detail-list">
										<dl class="detail-list__item">
											<dt>Accept vendor leads</dt>
											<dd>
												<bool-icon :value="activeItem.info.agree.accept_vendor_leads"/>
											</dd>
										</dl>
										<dl class="detail-list__item">
											<dt>Receive introduction fees</dt>
											<dd>
												<bool-icon :value="activeItem.info.agree.receive_introduction_fees"/>
											</dd>
										</dl>
										<dl class="detail-list__item">
											<dt>Introduce conveyancing</dt>
											<dd>
												<bool-icon :value="activeItem.info.agree.introduce_conveyancing"/>
											</dd>
										</dl>
										<dl class="detail-list__item">
											<dt>Introduce other services</dt>
											<dd>
												<bool-icon :value="activeItem.info.agree.introduce_other_services"/>
											</dd>
										</dl>
									</div>
								</section>
							</template>
							<template
								v-if="$enum('ServiceProviderTypes').solicitor === activeItem.service_provider_type">
								<section class="section">
									<header>
										<h1 class="beta">Sources</h1>
									</header>
									<div class="detail-list">
										<dl class="detail-list__item">
											<dt>Online comparisons</dt>
											<dd>
												<bool-icon :value="activeItem.info.sources.online_comparisons"/>
											</dd>
										</dl>
										<dl class="detail-list__item">
											<dt>Estate agents</dt>
											<dd>
												<bool-icon :value="activeItem.info.sources.estate_agents"/>
											</dd>
										</dl>
										<dl class="detail-list__item">
											<dt>Valued partners</dt>
											<dd>
												<bool-icon :value="activeItem.info.sources.valued_partners"/>
											</dd>
										</dl>
									</div>
								</section>
								<section class="section">
									<header>
										<h1 class="beta">Agreements</h1>
									</header>
									<div class="detail-list">
										<dl class="detail-list__item">
											<dt>Purchase conveyancing instructions</dt>
											<dd>
												<bool-icon
													:value="activeItem.info.agree.purchase_conveyancing_instructions"/>
											</dd>
										</dl>
										<dl class="detail-list__item">
											<dt>Order private work</dt>
											<dd>
												<bool-icon :value="activeItem.info.agree.order_private_work"/>
											</dd>
										</dl>
									</div>
								</section>
							</template>
							<template
								v-if="$enum('ServiceProviderTypes').introducer === activeItem.service_provider_type">
								<section class="section">
									<header>
										<h1 class="beta">Introductions</h1>
									</header>
									<div class="detail-list">
										<dl
											v-for="(label, key) in $enum('ServiceTypes').display(null, true)"
											class="detail-list__item">
											<dt v-html="label"/>
											<dd>
												<bool-icon :value="activeItem.info.introductions[key]"/>
											</dd>
										</dl>
									</div>
								</section>
							</template>
						</template>
						<template v-if="$enum('InvitationTypesEnum').bdm === activeItem.invitation_type">
							<section class="section">
								<header>
									<h1 class="beta">Introductions</h1>
								</header>
								<div class="detail-list">
									<dl class="detail-list__item">
										<dt>Law firms</dt>
										<dd>
											<bool-icon :value="activeItem.info.bdm_introductions.law_firms"/>
										</dd>
									</dl>
									<dl class="detail-list__item">
										<dt>Estate agents</dt>
										<dd>
											<bool-icon :value="activeItem.info.bdm_introductions.estate_agents"/>
										</dd>
									</dl>
								</div>
							</section>
						</template>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import {createNamespacedHelpers} from "vuex";

const {mapActions, mapGetters} = createNamespacedHelpers("invitations");

export default {
	computed: mapGetters([
		"activeItem",
	]),

	methods: mapActions([
		"activateModel",
	]),

	created() {
		this.activateModel(this.$route.params.invitation);
	},
};
</script>
